export class JGridConstant {
  static readonly CONDITION_SINGLETYPE_SINGLE = 'single';
  static readonly CONDITION_SINGLETYPE_TWORANGE = 'twoRange';
  static readonly CONDITION_SINGLETYPE_MULTIPLERANGE = 'multipleRange';

  static readonly CONDITION_INPUTTYPE_LABELCLICK = 'labelClick';
  static readonly CONDITION_INPUTTYPE_TEXT = 'text';
  static readonly CONDITION_INPUTTYPE_NUMBER = 'number';
  static readonly CONDITION_INPUTTYPE_DATE = 'date';
  static readonly CONDITION_INPUTTYPE_DATETIME = 'dateTime';

  static readonly CONDITION_RULETYPE_STANDARD = 'standard';
  static readonly CONDITION_RULETYPE_SPECIAL = 'special';

  static readonly CONDITION_VALUE_CONTAIN_ALL = 'CONTAIN_ALL';

  static readonly JGRID_CHECKBOX = 'checkbox';
  static readonly JGRID_RADIO = 'radio';

  static readonly OPTION_SINGLE = 'single';
  static readonly OPTION_GROUP = 'group';
  static readonly OPTION_LIKE_ANYWHERE = 'LIKE_ANYWHERE';
  static readonly OPTION_LIKE_START = 'LIKE_START';
  static readonly OPTION_BTD = 'BTD';
  static readonly OPTION_LIKE_END = 'LIKE_END';
  static readonly OPTION_IN = 'IN';
  static readonly OPTION_NOT_IN = 'NOT_IN';
  static readonly OPTION_LEDATE = 'LEDATE';
  static readonly CREATE_ = 'CREATE_'; //新建
  static readonly REFRESH_ = 'REFRESH_'; // 刷新
  static readonly DELETE_ = 'DELETE_'; // 删除
  static readonly EXPORT_ = 'EXPORT_';
  static readonly IMPORT_ = 'IMPORT_';
  static readonly SYNC_ALL_ = 'SYNC_ALL_'; // 同步全部
  static readonly SYNC_CUSTOM_ = 'SYNC_CUSTOM_'; // 同步
  static readonly DIRECTION_DESC = 'DESC';

}
